import { BRAND_ASSETS } from "@/lib/brand-assets";
import Image from "next/image";

export type BrandMascotPose = "signature" | "teaching";

interface BrandMascotProps {
  pose?: BrandMascotPose;
  className?: string;
  priority?: boolean;
  alt?: string;
  sizes?: string;
}

const MASCOT_DIMENSIONS: Record<BrandMascotPose, { width: number; height: number }> = {
  signature: { width: 1024, height: 1536 },
  teaching: { width: 1000, height: 1200 },
};

export function BrandMascot({
  pose = "signature",
  className,
  priority = false,
  alt = "",
  sizes = "(max-width: 640px) 280px, 320px",
}: BrandMascotProps) {
  const dimensions = MASCOT_DIMENSIONS[pose];

  return (
    <Image
      src={BRAND_ASSETS.mascot[pose]}
      alt={alt}
      width={dimensions.width}
      height={dimensions.height}
      className={className}
      priority={priority}
      sizes={sizes}
    />
  );
}
